import { DeleteEvent, GetEvent, PatchEvent, SubmitEvent } from '~/machines/base-crud';
import { MalpracticeInsurance } from '~/types';
import { deleteData, getData, patchData, postData } from '~/utils/service';
import { InsuranceContext, MalpracticeInsuranceFormValues } from './types';
import { malInsuranceApiToForm, malInsuranceFormToApi, malInsurancesApiToForm } from './utils';

export const INSURANCE_ROUTES = {
  get: '/malpractice-insurance',
  post: '/malpractice-insurance',
  patch: '/malpractice-insurance/{id}',
  delete: '/malpractice-insurance/{id}',
};
export const ROUTE_NAME = 'malpracticeInsurance';
interface InsuranceInput<T> {
  input: {
    context: InsuranceContext;
    event: T;
  };
}

export const API_CALLS = {
  get: async ({ input }: InsuranceInput<GetEvent>): Promise<MalpracticeInsurance[]> => {
    return await getData(ROUTE_NAME, {
      sort: input.context.sort,
      transformResponse: malInsurancesApiToForm,
    });
  },
  create: async ({
    input,
  }: InsuranceInput<
    SubmitEvent<MalpracticeInsuranceFormValues>
  >): Promise<MalpracticeInsurance> => {
    return await postData(ROUTE_NAME, {
      data: input.event.values,
      transformRequest: malInsuranceFormToApi,
      transformResponse: malInsuranceApiToForm,
    });
  },
  delete: async ({ input }: InsuranceInput<DeleteEvent>) => {
    return await deleteData(ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    });
  },
  patch: async ({
    input,
  }: InsuranceInput<PatchEvent<MalpracticeInsuranceFormValues>>): Promise<MalpracticeInsurance> =>
    await patchData(ROUTE_NAME, {
      pathParams: { id: input.event.values.id?.toString() || '' },
      data: input.event.values,
      transformRequest: malInsuranceFormToApi,
      transformResponse: malInsuranceApiToForm,
    }),
};
